<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				编辑服务套餐
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
			<!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
		</div>
		<div class="wrap">
			<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px" :rules='rules'>
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="分类">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds" :options="categoryData[2].children"
					:show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="套餐名称" prop="title">
					<el-input v-model="editParams.title" size="mini" style="width: 200px;" placeholder="请输入商品描述"></el-input>
				</el-form-item>
				<el-form-item label="适用品种" prop="applyType">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否复购">
					<el-radio-group v-model="editParams.buy_back">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="线上线下">
					<el-radio-group v-model="editParams.group_type">
						<el-radio label="1">线上</el-radio>
						<el-radio label="0">线下</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否参与提成">
					<el-radio-group v-model="editParams.join_commission">
						<el-radio :label="Number('0')">否</el-radio>
						<el-radio :label="Number('1')">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="套餐总价">
					<el-input style="width: 150px;" size="mini" v-model="editParams.total_money" @change="changetotalmoney" placeholder="请输入内容"></el-input>
				</el-form-item>
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<div class="tit">
					<span class="name">设置服务项</span>
				</div>

				<el-form-item label="结算后订单是否可更换" label-width="180px">
					<el-radio-group v-model="editParams.checkout_replace.support_replace">
						<el-radio :label="Number(0)">否</el-radio>
						<el-radio :label="Number(1)">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="结算订单后更换折扣率" v-if="editParams.checkout_replace.support_replace==1" label-width="180px">
					<span>{{editParams.checkout_replace.replace_discount_rate}}</span>
					<!-- <el-input-number size="mini" v-model="editParams.checkout_replace.replace_discount_rate" :min="0" :max="1" label="描述文字"></el-input-number> -->
					<!-- <span style="margin-left: 5px;color: #FF0000;">建议折扣为 {{(Number(editParams.total_money)/total_money).toFixed(2)}}</span> -->
					<!-- <span style="margin-left: 5px;color: #e6a23c;">折扣率请输入0-1之间的数字 </span> -->
				</el-form-item>
				<el-form-item label="">
					<el-button size="small" type="warning" @click="dialogAddShop_state = true;tree=[{id:'602f1e88c904d9db7ccf3bec'},{id:'601d11cfa93f55b5cf3ae2eb'}]">添加物品</el-button>
				</el-form-item>
				<div style="padding: 0 50px;">
					<el-table :data="editParams.group_items" show-summary>
						<el-table-column prop="goods_name" label="商品名称">
						</el-table-column>
						<el-table-column prop="brand_name" label="品牌">
						</el-table-column>

						<el-table-column label="规格">
							<template slot-scope="scope">
								<span>{{scope.row.sku_name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="数量" prop="use_num">
							<template slot-scope="scope">
								<el-input style="width: 100px;" type='number' size='small' @change='(val)=>{changeUseNum(scope.row,val)}' v-model.number="scope.row.use_num" placeholder="请输入数量"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="出库量" prop="out_num"> 
							<template slot-scope="scope">
								<el-input style="width: 100px;" type='number' size='small' @change='(val)=>{changeOutNum(scope.row,val)}' v-model.number="scope.row.out_num" placeholder="请输入数量"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="原单价" prop="src_price">
						</el-table-column>
						<el-table-column label="原总价"  prop="src_totalmomey">
							
						</el-table-column>
						<el-table-column label="折后单价" prop="custom_price">
							
						</el-table-column>
						<el-table-column label="折后总价" prop="custom_total_money">
							
						</el-table-column>
						<el-table-column label="操作" width="120px">

							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-delete" type='danger' @click="editParams.group_items.splice(scope.$index,1)"></el-button>

							</template>
						</el-table-column>
					</el-table>


				</div>
			</el-form>
		</div>
		<div v-if="dialogAddShop_state">
			<dialogNewGoods @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" :tree='tree' @submit='getgoods'></dialogNewGoods>
		</div>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="primary" size="small" :loading="loading" @click='submit'>确定</el-button>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {
		setServiceGroup,
		getServiceGroupDl,
		getProductTypeList,
		getProductTypeDl,
	} from '../../../api/productApi.js'
	import dialogNewGoods from "../../../components/dialog_addShop.vue"
	import storeSelect from "../../../components/storeSelect.vue"
	export default {
		components: {
			storeSelect,
			dialogNewGoods
		},

		data() {
			return {
				dialogAddShop_state: false,
				planCurrentrow: '',
				rules: {
					title: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				tree: [],
				productTypeIds: [],
				editParams: {
					groupId: '',
					title: '',
					category_info: {
						_id: '',
						name: '',
						code: '',
					},
					buy_back:1,
					group_type:'0',
					category_list: [],
					applyType: '0',
					buy_way: '0',
					checkout_replace: {
						support_replace: 0,
						replace_discount_rate: 0,
					},
					group_items: [],
					join_commission: 1,
					shop_info: [],
					total_money: 1,
				},
				loading: false,
				storeIds: [],
				showShops: true,
				categoryData: [],
			}
		},
		computed: {
			total_money() {
				var total=0;
				this.editParams.group_items.forEach(item => {
					total += item.src_totalmomey;
				})
				return this.$public.toDoubleFixed2(total);
			},
			
		},
		watch: {
			'editParams.group_items': {
				handler: function() {
					let finaltotal ;
					var totals = 0;
					this.editParams.group_items.forEach(item => {
						if(item.goods_type ==1){
						if(item.model.medical_ext_info.allow_wholesale==1){
							item.src_totalmomey = this.$public.toDoubleFixed2(item.src_price * item.use_num)
						}else{
							item.src_totalmomey = this.$public.toDoubleFixed2(item.src_price * item.out_num)
						}
						}else{
							
							item.src_totalmomey = this.$public.toDoubleFixed2(item.src_price * item.use_num)
						}
						totals += item.src_totalmomey;
					})
					finaltotal = this.$public.toDoubleFixed2(totals)
					this.editParams.checkout_replace.replace_discount_rate = Number(Math.floor(Number(this.editParams.total_money)*100.0 / finaltotal)/100.0).toFixed(2)
					let sum = 0;
					this.editParams.group_items.forEach((item,index) => {
							item.custom_price = (item.src_price * this.editParams.checkout_replace.replace_discount_rate).toFixed(2);
							
							if(index != this.editParams.group_items.length-1){
								item.custom_total_money = (item.src_totalmomey*this.editParams.checkout_replace.replace_discount_rate).toFixed(2);
								sum += Number(item.custom_total_money);
							}else{
								item.custom_total_money = this.$public.toDoubleFixed2((Number(this.editParams.total_money) - sum))
								item.custom_price = this.$public.toDoubleFixed2(item.custom_total_money/item.use_num)
							}
					})
					
				},
			}

		},
		methods: {
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/group/group',
						query: {
							type: 4
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						setServiceGroup(this.editParams).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.$router.push({
									path: '/group/group',
									query: {
										type: 4
									}
								})
							}
						})
					} else {

						return false;
					}
				});
			},
			totalcomputer(){
				let finaltotal ;
				var totals = 0;
				this.editParams.group_items = this.editParams.group_items.sort((a,b)=>{
					return a.goods_type-b.goods_type
				})
				this.editParams.group_items.forEach(item => {
					if(item.goods_type ==1){
					if(item.model.medical_ext_info.allow_wholesale==1){
						item.src_totalmomey = this.$public.toDoubleFixed2(item.src_price * item.use_num)
					}else{
						item.src_totalmomey = this.$public.toDoubleFixed2(item.src_price * item.out_num)
					}
					}else{
						
						item.src_totalmomey = this.$public.toDoubleFixed2(item.src_price * item.use_num)
					}
					totals += item.src_totalmomey;
				})
				finaltotal = this.$public.toDoubleFixed2(totals)
				this.editParams.checkout_replace.replace_discount_rate = Number(Math.floor(Number(this.editParams.total_money)*100.0 / finaltotal)/100.0).toFixed(2)
				let sum=0
				this.editParams.group_items.forEach((item,index) => {
						item.custom_price = (item.src_price * this.editParams.checkout_replace.replace_discount_rate).toFixed(2);
						if(index != this.editParams.group_items.length-1){
							item.custom_total_money = (item.src_totalmomey*this.editParams.checkout_replace.replace_discount_rate).toFixed(2);
							sum += Number(item.custom_total_money);
						}else{
							item.custom_total_money = this.$public.toDoubleFixed2((Number(this.editParams.total_money) - sum))
							item.custom_price = this.$public.toDoubleFixed2(item.custom_total_money/item.use_num)
							
							
						}
						
				})
			},

			getStores(data) {
				this.editParams.shop_info = data;
			},
			getgoods(data) {
				console.log(data)
				this.editParams.group_items.push({
					goods_type: data.goodsType,
					goods_id: data.goodsType == 1 ? data.goodsItem.medical_id : data.goodsItem.serviceId,
					sku_id: data.skuItem == '无' ? '' : data.skuItem.service_objectId,
					sku_name: data.skuItem == '无' ? data.goodsItem.old_packinfo_info.sku_value : data.skuItem.service_objectName,
					use_num: 1,
					out_num: 1,
					goods_name: data.goodsItem.title,
					brand_name: data.goodsItem.brand_name,
					src_price:data.goodsType == 1 ? (data.goodsItem.medical_ext_info.allow_wholesale == 0 ? (data.goodsItem.pprice /
						data.goodsItem.old_packinfo_info.in_exchanage).toFixed(2) : data.goodsItem.pprice) : data.skuItem.price,
					custom_price: 0,
					src_totalmomey:0,
					custom_total_money: 0,
					model:{
						medical_ext_info:{
							allow_wholesale:data.goodsType == 1?data.goodsItem.medical_ext_info.allow_wholesale:'',
							dosage_ceiling: data.goodsType == 1?data.goodsItem.medical_ext_info.dosage_ceiling:'',
							dosage_ceiling_value:data.goodsType == 1?data.goodsItem.medical_ext_info.dosage_ceiling_value:'',
							time_useable:data.goodsType == 1?data.goodsItem.medical_ext_info.time_useable:'',
							use_times:data.goodsType == 1?data.goodsItem.medical_ext_info.use_times:'',
						},
						pprice:data.goodsItem.pprice,
						old_packinfo_info:{
							in_exchanage:data.goodsType == 1?data.goodsItem.old_packinfo_info.in_exchanage:'',
						},
					}
				})
			},
			getServiceGroupDl(id) {
				this.showShops = false;

				getServiceGroupDl({
					id
				}).then(res => {
					if (res.code == 0) {
						this.editParams = res.data;
						this.productTypeIds = [];
						this.productTypeIds.push(res.data.category_info._id);
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.showShops = true;

					}
				})
			},
			getProductTypeList() {
				getProductTypeList({
					category: '套餐'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data[0].children;
					}
				})
			},
			changeCategory(val) {
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
			changeOutNum(row,val){
				if(row.goods_type==1){
				row.out_num = this.$public.replaceGoodsDosage(row.out_num);
				let use_num = Math.ceil(this.$public.chu(Number(row.out_num),row.model.old_packinfo_info.in_exchanage))
				row.use_num = use_num;
				}else{
					row.use_num  =val;
				}
				this.totalcomputer()
			},
			changeUseNum(row,val){
			if(row.goods_type==1){
				row.use_num = Math.floor(row.use_num)
				row.use_num = this.$public.replaceGoodsDosage(row.use_num);
				let out_num = this.$public.cheng(row.use_num,row.model.old_packinfo_info.in_exchanage)
				row.out_num = out_num;
				}else{
					row.out_num = val;
				}
				this.totalcomputer()
			},
			changetotalmoney(){
				this.editParams.checkout_replace.replace_discount_rate = Number(Math.floor(Number(this.editParams.total_money)*100.0 / this.total_money)/100.0).toFixed(2)
				this.totalcomputer()
			}
		},
		created() {
			this.getProductTypeList();
			if (this.$route.query.id) {
				this.getServiceGroupDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.userInfo.shops.map(item => {
					return item.shop_id
				})
				this.editParams.shop_info = this.$store.state.userInfo.shops
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		.wrap {
			background-color: #fff;
			padding-bottom: 20px;
		}

		.tit {
			font-size: 16px;
			margin-bottom: 28px;
			height: 40px;
			line-height: 40px;
			border-radius: 3px;
			padding-left: 10px;

			.name {
				padding-left: 5px;
				border-left: 2px solid #F5882A;
			}
		}

		.footer {
			background-color: #fff;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
	}
</style>
